import React, { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { PlaylistRemove } from '@mui/icons-material';

interface Props {
  action?: ReactNode;
}

export const ListEmpty = ({ action }: Props) => {
  return (
    <Stack height="100%" width="100%" alignItems="center" justifyContent="center">
      <Typography color="textSecondary" variant="h6" component="span">
        List empty
      </Typography>

      <PlaylistRemove sx={{ fontSize: '3rem' }} color="disabled" />

      {action}
    </Stack>
  );
};
